exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cust-xport-conf-crud .group-tags .el-tag{background-color:#fff;color:#333;border-color:#ccc;border-style:dashed;cursor:default}.cust-xport-conf-crud .group-tags .el-tag.selected{border-color:#409eff;border-style:solid}.cust-xport-conf-crud .group-tags .el-tag.required{cursor:not-allowed;font-weight:700}.cust-xport-conf-crud .group-tags .el-tag.required.selected{color:#000;background-color:#eff5ff}.cust-xport-conf-crud .group-tags .el-tag.selectable{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-80b4340a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compo/comn/CustXportConfCrud.vue
// module id = 4656
// module chunks = 0